import { dayOfWeekMapping } from '../hooks/useSpecialistWorkingHours'
import useTranslateMessage from '../hooks/useTranslateMessage'
import { PracticeWorkingOpeningHours } from '../types/profile'

export const useWorkingHoursToStringDetailed = (workingOpeningHours: PracticeWorkingOpeningHours | null) => {
  const translate = useTranslateMessage()

  if (!workingOpeningHours) {
    return ''
  }

  return Object.entries(dayOfWeekMapping)
    .map(([key, value]) => {
      const workingTimes = workingOpeningHours?.[value]
      if (!workingTimes?.length) {
        return ''
      }

      // todo: refactor
      // eslint-disable-next-line sonarjs/no-nested-template-literals
      return `${translate(key)} (${workingTimes.map(({ open, close }) => `${open} - ${close}`).join(', ')})`
    })
    .filter(Boolean)
    .join(', ')
}

export const useWorkingHoursToStringGrouped = (workingOpeningHours: PracticeWorkingOpeningHours | null) => {
  const translate = useTranslateMessage()

  if (!workingOpeningHours) {
    return ''
  }

  try {
    const dayGroups: { days: number[]; time: string }[] = []

    Object.keys(workingOpeningHours)
      .map(Number)
      .sort((a, b) => a - b)
      .forEach((day) => {
        // requested to display only 24 hr text
        const time = JSON.stringify(workingOpeningHours[day].filter((f) => f.close === '23:59' && f.open === '00:00'))
        const lastGroup = dayGroups[dayGroups.length - 1]

        if (lastGroup && lastGroup.time === time) {
          lastGroup.days.push(day)
        } else {
          dayGroups.push({ days: [day], time })
        }
      })

    const daysMap = Object.fromEntries(Object.entries(dayOfWeekMapping).map((a) => a.reverse()))

    return dayGroups
      .map(({ days, time }) => {
        const { open, close } = JSON.parse(time)[0]

        const startDayKey = daysMap[days[0]]
        const endDayKey = daysMap[days.length]

        const dayText =
          days.length > 1
            ? translate('day_to_day', { from: translate(startDayKey), to: translate(endDayKey) })
            : translate(startDayKey)
        let timeText = `(${open}-${close})`
        if (open === '00:00' && close === '23:59') {
          timeText = '24 hr'
        }
        return `${dayText} ${timeText}`
      })
      .join(', ')
  } catch (_) {
    console.error('Working hours to string operation failed')
    // fallback to empty string
    return ''
  }
}
